/**
 * Helper function to deduplicate dropdown options.
 *
 * @param {Array} data - The data to be processed.
 * @param {string} idKey - The key to be used as the unique ID.
 * @param {string} labelKey - The key to be used for the label.
 * @returns {Array} An array of deduplicated dropdown options or undefined if no data.
 */
export const getDeduplicatedDropdownOptions = (data, idKey, labelKey) => {
  if (!data) return undefined;

  return Array.from(
    new Map(
      data
        .filter((item) => item[idKey] && item[labelKey])
        .map((item) => [
          item[idKey],
          { id: item[idKey], fallback: item[labelKey] },
        ])
    ).values()
  );
};
